import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import _ from 'lodash';
import StickyHeaderTable from '../../common/ui/StickyHeaderTable';
import { showModal } from '../../../actions/ModalActions';
import { fetchRsvpOverviewList, getGuestGroup, toggleRsvpFacetValueV2, toggleSortByNameAsc, selectEventTab } from '../../../actions/GuestActions';
import GlobalStats from '../common/GlobalStats';
import Facets from './Facets';
import { PrefixToLabel } from './GuestListTypes';
import Loader from '../../common/ui/Loader';
// import NoGuests from './NoGuests';
import { isNameUnknown } from './util';
import { EmptyState } from './EmptyState';

import nameCardWithQuestionMarks from '../../../../public/images/doodles/namecard_with_question_marks.svg';

const RsvpQuestionGuestCell = ({ questionId, guestGroup, rowSpan }) => {
  const guestRsvpQA = _.find(guestGroup.rsvp_question_answers, qa => qa.rsvp_question_id === questionId);

  return (
    <td rowSpan={rowSpan}>
      {guestRsvpQA && guestRsvpQA.answer}
    </td>
  );
};

RsvpQuestionGuestCell.propTypes = {
  questionId: PropTypes.number.isRequired,
  guestGroup: PropTypes.shape({}).isRequired,
  rowSpan: PropTypes.number.isRequired
};

class GuestGroupRow extends Component {
  constructor(props) {
    super(props);

    this.rowCheck = this.rowCheck.bind(this);
    this.rowClick = this.rowClick.bind(this);

    this.state = {
      active: true,
      timeout: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { modalOpen, onSelectGuestGroup } = this.props;
    if (modalOpen && (nextProps.modalOpen === false)) {
      this.setState({
        timeout: setTimeout(() => onSelectGuestGroup(null), 1000)
      });
    }
  }

  componentWillUnmount() {
    const { timeout } = this.state;
    if (timeout) {
      clearTimeout(timeout);
    }
  }

  rowCheck() {
    const { guestGroup, onRowCheck, isRowChecked } = this.props;
    onRowCheck(guestGroup.id, !isRowChecked);
  }

  rowClick(e) {
    const { guestGroup, activeEventTab, onEditGuestGroup, onSelectGuestGroup } = this.props;
    if (e.target.hasAttribute('data-no-edit')) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    } else {
      onEditGuestGroup(guestGroup.id, activeEventTab);
      onSelectGuestGroup(guestGroup.id);
    }
  }

  renderRsvpResponseIcon(eventInvitations, eventId) {
    const response = _.find(eventInvitations, { event_id: eventId });
    if (response) {
      switch (response.rsvp_type) {
        case 'ATTENDING': {
          return <span className="zolaicon zolaicon-checkmark" style={{ color: '#19A731' }} />;
        }
        case 'DECLINED': {
          return <span className="zolaicon zolaicon-close" style={{ color: '#C7133E' }} />;
        }
        default: {
          return <span className="text-muted">?</span>;
        }
      }
    }
    return <span className="text-muted">?</span>;
  }

  renderRsvpResponseDetail(eventInvitations, eventId) {
    const response = _.find(eventInvitations, { event_id: eventId });
    if (response) {
      switch (response.rsvp_type) {
        case 'ATTENDING': {
          return <span style={{ color: '#19A731' }}>Attending</span>;
        }
        case 'DECLINED': {
          return <span style={{ color: '#C7133E' }}>Declined</span>;
        }
        case 'NO_RESPONSE': {
          return <span className="text-muted">No Response</span>;
        }
        default: {
          return <span className="text-muted">No Response</span>;
        }
      }
    }
    return <span className="text-muted">Not Invited</span>;
  }

  renderMealOptionResponse(eventInvitations, eventId) {
    const { mealOptions } = this.props;
    const eventInvitation = _.find(eventInvitations, { event_id: eventId });
    if (eventInvitation && eventInvitation.meal_option_id) {
      if (mealOptions[eventInvitation.meal_option_id]) {
        const mealOptionName = _.capitalize(mealOptions[eventInvitation.meal_option_id].name);
        if (mealOptionName.length > 30) {
          return `${mealOptionName.slice(0, 30)}...`;
        }
        return mealOptionName;
      }
    }
    return null;
  }

  renderRsvpQuestionAnswer(rsvpQuestionAnswers, questionId) {
    const answer = _.find(rsvpQuestionAnswers, { rsvp_question_id: questionId });
    if (answer) {
      return answer.answer;
    }
    return '';
  }

  render() {
    const {
      guestGroup,
      isRowChecked,
      onSelectGuestGroup,
      isActive,
      events,
      activeEventTab,
    } = this.props;

    const [primaryGuest, ...otherGuests] = guestGroup.guests;

    const event = events.byId[activeEventTab];

    return (
      <tr
        className={isActive ? 'table-row table-row-active' : 'table-row'}
        onClick={this.rowClick}
        onMouseEnter={() => onSelectGuestGroup(guestGroup.id)}
      >
        <td>
          <div className="checkbox checkbox-table checkbox-secondary">
            <label htmlFor={`guests-${guestGroup.id}`} data-no-edit>
              <input
                type="checkbox"
                id={`guests-${guestGroup.id}`}
                data-no-edit
                checked={isRowChecked}
                onClick={this.rowCheck}
              />
              <span className="input-override" data-no-edit><i className="zolaicon zolaicon-checkmark" data-no-edit /></span>
            </label>
          </div>
        </td>
        <td className="guest-group-list">
          <div>{PrefixToLabel[primaryGuest.prefix]} {primaryGuest.first_name} <strong>{primaryGuest.family_name}</strong></div>
          <ul className="list-indent" style={{ paddingLeft: 0 }}>
            {otherGuests.length > 0 && otherGuests.map(otherGuest => (
              <li key={otherGuest.id}>
                {isNameUnknown(otherGuest) ? (
                  <span>{otherGuest.relationship_type === 'CHILD' ? 'Child' : 'Guest'}</span>
                ) : (
                  <span>{PrefixToLabel[otherGuest.prefix]} {otherGuest.first_name} {otherGuest.family_name}</span>
                )}
              </li>
            ))}
          </ul>
        </td>
        <td style={{ textAlign: 'center' }}>
          <ul className="list-indent" style={{ paddingLeft: 0 }}>
            {guestGroup.guests.map(guest => (
              <li key={guest.id} className="rsvp-response">
                <div className="response-icon">
                  {event && this.renderRsvpResponseIcon(guest.event_invitations, event.id)}
                </div>
                <div className="response-detail">
                  {event && this.renderRsvpResponseDetail(guest.event_invitations, event.id)}
                </div>
              </li>
            ))}
          </ul>
        </td>
        {event && event.meal_options && event.meal_options.length > 0 && (
          <td className="meal-choices-list">
            <ul className="list-indent meal-choices" style={{ paddingLeft: 0 }}>
              {guestGroup.guests.map(guest => (
                <li key={guest.id} className="meal-choice">
                  {event && this.renderMealOptionResponse(guest.event_invitations, event.id)}
                </li>
              ))}
            </ul>
          </td>
        )}
        {event && event.rsvp_questions && event.rsvp_questions.map(question => (
          <td key={question.id}>
            <div>{this.renderRsvpQuestionAnswer(guestGroup.rsvp_question_answers, question.id)}</div>
          </td>
        ))}
      </tr>
    );
  }
}

GuestGroupRow.propTypes = {
  guestGroup: PropTypes.shape({}),
  onEditGuestGroup: PropTypes.func.isRequired,
  onRowCheck: PropTypes.func.isRequired,
  isRowChecked: PropTypes.bool.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool,
  isActive: PropTypes.bool,
  events: PropTypes.shape({}),
  activeEventTab: PropTypes.number,
  mealOptions: PropTypes.shape({})
};


class RsvpEventHeader extends Component { // eslint-disable-line
  render() {
    const {
      checkAllRows,
      checkedAllRows,
      sortByNameAsc,
      onToggleSort,
      headerStyle,
      events,
      activeEventTab,
    } = this.props;

    const event = events.byId[activeEventTab];

    return (
      <thead className="table-header" style={headerStyle}>
        <tr>
          <th className="td-checkbox">
            <div className="checkbox checkbox-table">
              <label htmlFor="guests-select-all">
                <input
                  type="checkbox"
                  id="guests-select-all"
                  onClick={checkAllRows}
                  checked={checkedAllRows}
                />
                <span className="input-override"><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Select all guests on this page."><i className="zolaicon zolaicon-checkmark" /></div></span>
              </label>
            </div>
          </th>
          <th className="sortable" role="button" onClick={onToggleSort}>
            <div className="with-tooltip visible-md visible-lg" data-tooltip="View guests by last name, ascending or descending."><span className="tooltip-span">Name <i className={`zolaicon zolaicon-arrow-${sortByNameAsc ? 'up' : 'down'}`} /></span></div>
            <div className="visible-xs visible-sm">Name <i className={`zolaicon zolaicon-arrow-${sortByNameAsc ? 'up' : 'down'}`} /></div>
          </th>
          <th style={{ textAlign: 'center' }}>
            <div>RSVP</div>
            <div className="text-muted rsvp-table-subheader" style={{ textTransform: 'none', fontWeight: 300, letterSpacing: 1 }}>
              {event && event.collect_rsvps ? 'Online RSVP Enabled' : 'Online RSVP Disabled'}
            </div>
          </th>
          {event && event.meal_options.length > 0 && (
            <th className="rsvp-table-header">
              <div>Meal Preference</div>
            </th>
          )}
          {event && event.rsvp_questions && event.rsvp_questions.map(question => (
            <th key={question.id} className="rsvp-table-header">
              <div>{question.question.length > 40 ? `${question.question.slice(0, 40)}...` : question.question}</div>
            </th>
          ))}
        </tr>
      </thead>
    );
  }
}

RsvpEventHeader.propTypes = {
  headerStyle: PropTypes.objectOf(PropTypes.string),
  checkAllRows: PropTypes.func.isRequired,
  checkedAllRows: PropTypes.bool.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  events: PropTypes.shape({}),
  activeEventTab: PropTypes.number,
};

// must be a class component for sticky header to work properly
class RsvpEventTable extends Component { // eslint-disable-line
  render() {
    const {
      checkAllRows,
      checkedAllRows,
      sortByNameAsc,
      onToggleSort,
      filteredIds,
      selectedGuestGroupId,
      guestGroups,
      onEditGuestGroup,
      checkedRows,
      checkRow,
      onSelectGuestGroup,
      editGuestModalOpen,
      headerStyle,
      events,
      activeEventTab,
      mealOptions,
      tableId,
    } = this.props;

    return (
      <table className="table guest-table-v2 table-fixed-header-round round-bottom" id={tableId}>
        <RsvpEventHeader
          events={events}
          activeEventTab={activeEventTab}
          checkAllRows={checkAllRows}
          checkedAllRows={checkedAllRows}
          sortByNameAsc={sortByNameAsc}
          onToggleSort={onToggleSort}
          style={headerStyle}
        />
        <tbody>
          {filteredIds.map(guestGroupId => (
            <GuestGroupRow
              key={guestGroupId}
              isActive={selectedGuestGroupId === guestGroupId}
              guestGroup={guestGroups[guestGroupId]}
              onEditGuestGroup={onEditGuestGroup}
              isRowChecked={_.includes(checkedRows, guestGroupId)}
              onRowCheck={checkRow}
              onSelectGuestGroup={onSelectGuestGroup}
              modalOpen={editGuestModalOpen}
              events={events}
              activeEventTab={activeEventTab}
              mealOptions={mealOptions}
            />
          ))}
        </tbody>
      </table>
    );
  }
}

RsvpEventTable.defaults = {
  headerStyle: {},
  selectedGuestGroupId: null
};

RsvpEventTable.propTypes = {
  headerStyle: PropTypes.objectOf(PropTypes.string),
  checkedAllRows: PropTypes.bool.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  editGuestModalOpen: PropTypes.bool.isRequired,
  selectedGuestGroupId: PropTypes.number,
  filteredIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  checkedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  guestGroups: PropTypes.shape({}).isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  checkRow: PropTypes.func.isRequired,
  checkAllRows: PropTypes.func.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  events: PropTypes.shape({}),
  activeEventTab: PropTypes.number,
  mealOptions: PropTypes.shape({}),
  tableId: PropTypes.string,
};


class RsvpEvent extends Component {
  constructor(props) {
    super(props);

    this.checkRow = this.checkRow.bind(this);
    this.checkAllRows = this.checkAllRows.bind(this);
    this.unCheckAllRows = this.unCheckAllRows.bind(this);
    this.resetFacets = this.resetFacets.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.afterExport = this.afterExport.bind(this);
    this.selectEventTab = this.selectEventTab.bind(this);
    this.toggleGuestBreakdown = this.toggleGuestBreakdown.bind(this);
    this.showAllGuests = this.showAllGuests.bind(this);

    this.state = {
      checkedRows: [],
      checkedAllRows: false,
      showGuestBreakdown: false,
    };
  }

  componentDidMount() {
    const { events, getGuestList, params } = this.props;
    const { eventUUID } = params;
    if (eventUUID) {
      const { uuidToId } = events;
      this.selectEventTab(uuidToId[eventUUID]);
    }
    getGuestList();
  }

  componentWillReceiveProps(nextProps) {
    const { events, getGuestList, onUnload } = this.props;
    const { filteredIds } = nextProps;
    const { checkedRows } = this.state;

    const nextCheckedRows = _.intersection(checkedRows, filteredIds);
    const nextCheckedAllRows = nextCheckedRows.length !== 0 && nextCheckedRows.length === filteredIds.length;

    this.setState({
      checkedRows: nextCheckedRows,
      checkedAllRows: nextCheckedAllRows,
    });
    const { uuidToId } = events;
    if (nextProps.params.eventUUID !== this.props.params.eventUUID) { // eslint-disable-line
      onUnload(); // not sure if this is necessary/best
      this.resetAll(); // not sure if this is necessary/best
      if (nextProps.params.eventUUID) { // eslint-disable-line
        this.selectEventTab(uuidToId[nextProps.params.eventUUID]); // eslint-disable-line
      } else {
        this.selectEventTab(null);
      }
      getGuestList();
    }
  }

  componentWillUnmount() {
    const { onUnload } = this.props;
    onUnload();
    this.resetAll();
    this.selectEventTab(null);
  }

  checkRow(id, isChecked) {
    const { filteredIds } = this.props;
    const { checkedRows } = this.state;

    if (isChecked) {
      checkedRows.push(id);
    } else {
      _.pull(checkedRows, id);
    }

    this.setState({
      checkedRows,
      checkedAllRows: filteredIds.length === checkedRows.length
    });
  }

  checkAllRows() {
    const { filteredIds } = this.props;
    const checkedAllState = !this.state.checkedAllRows;

    this.setState({
      checkedRows: checkedAllState ? filteredIds.slice() : [],
      checkedAllRows: checkedAllState
    });
  }

  unCheckAllRows() {
    this.setState({
      checkedRows: [],
      checkedAllRows: false
    });
  }

  afterExport() {
    const { onConfirmation } = this.props;
    this.exportDropdown.hide();
    onConfirmation('Guest RSVPs Exported');
  }

  resetFacets() {
    const { onResetFacets, getGuestList } = this.props;
    onResetFacets();
    getGuestList();
  }

  resetAll() {
    const { onResetSearchValue, onResetFacets, onSelectGuestGroup } = this.props; // eslint-disable-line
    onResetSearchValue();
    // onResetFacets();
    onSelectGuestGroup(null);
  }

  selectEventTab(id) {
    const { onSelectEventTab, getGuestList } = this.props; // eslint-disable-line
    this.unCheckAllRows();
    this.setState({
      showGuestBreakdown: false,
    });
    onSelectEventTab(id);
  }

  toggleGuestBreakdown() {
    this.setState(state => ({
      showGuestBreakdown: !state.showGuestBreakdown
    }));
  }

  showAllGuests() {
    const { onResetFacets, onResetSearchValue, getGuestList } = this.props;
    onResetSearchValue();
    onResetFacets();
    getGuestList();
  }

  render() {
    const {
      guestGroups,
      onEditGuestGroup,
      onToggleFacet,
      globalStats,
      numGuests,
      numSelectedFacets,
      sortByNameAsc,
      onToggleSort,
      selectedFacetValues,
      onGuestMessage,
      editGuestModalOpen,
      initialized,
      onSearchFilterGuestList,
      searchValue,
      filteredIds,
      onSelectGuestGroup,
      selectedGuestGroupId,
      events,
      activeEventTab,
      mealOptions,
    } = this.props;

    const { checkedRows, checkedAllRows, showGuestBreakdown } = this.state;

    if (!initialized) {
      return (
        <div className="guestlist-loader">
          <Loader delay />
        </div>
      );
    }

    const formattedRsvpResponseStats = [];
    const formattedGuestAgeStats = [];
    const formattedMealOptionStats = [];
    const formattedEventStats = [];
    // let numGuestsAttending = null;

    globalStats.forEach((globalStat) => {
      switch (globalStat.key) {
        case 'attending': {
          // numGuestsAttending = globalStat.value;
          formattedRsvpResponseStats.push(globalStat);
          break;
        }
        case 'declined':
        case 'no_responses': {
          formattedRsvpResponseStats.push(globalStat);
          break;
        }
        case 'adults':
        case 'children': {
          formattedGuestAgeStats.push(globalStat);
          // formattedGuestAgeStats.push(Object.assign({}, globalStat, { label: `${globalStat.label} attending` }));
          break;
        }
        default: {
          if (activeEventTab) {
            const event = events.byId[activeEventTab];
            if (event) {
              const mealOption = _.find(event.meal_options, { id: parseInt(globalStat.key, 10) });
              if (mealOption) {
                formattedMealOptionStats.push(Object.assign({}, globalStat, { label: _.capitalize(mealOption.name) }));
              }
            }
          } else if (events.byId[globalStat.key]) {
            const event = events.byId[globalStat.key];
            formattedEventStats.push(Object.assign({}, globalStat, { label: `Attending ${event.name}` }));
          }
        }
      }
    });

    const buildGuestListButton = {
      text: 'Invite Guests',
      action: () => browserHistory.push('/wedding/manage/guests/build')
    };

    return (
      <div>
        {numGuests === 0 ? (
          <EmptyState
            hed="No Guest List"
            body={<span>Build a guest list for this event, so you can track RSVPs here.</span>}
            button={buildGuestListButton}
            imgSrc={nameCardWithQuestionMarks}
          />
        ) : (
          <div>
            <div className="content-top">
              <div className="row global-stats-container" style={{ paddingLeft: '14px', borderBottom: showGuestBreakdown ? '1px solid #D9D9D9' : '' }}>
                <div className="col-xs-12 navbar-default" >
                  <ul className="nav navbar-nav navbar-left">
                    <li className="first-set"><GlobalStats stats={activeEventTab ? formattedRsvpResponseStats : formattedEventStats} /></li>
                    <li className="second-set"><GlobalStats stats={formattedGuestAgeStats} /></li>
                    <li className="third-set"><GlobalStats stats={formattedMealOptionStats} /></li>
                  </ul>
                </div>
              </div>
              {events.byId[activeEventTab] && !events.byId[activeEventTab].collect_rsvps && (
                <div className="row banner-container">
                  <div style={{ backgroundColor: '#F5B7BE', paddingTop: '10px', paddingBottom: '10px', marginLeft: '-30px', marginRight: '-30px', marginBottom: '15px' }}>
                    <div className="text-center">
                      <span className="banner-content">Guests cannot RSVP online to this event - if you want to change that, go to your event settings and enable online RSVP.</span>
                      <span className="banner-cta" style={{ marginLeft: '25px' }}>
                        <Link to="/wedding/manage/events" className="text-button" style={{ color: 'black' }}>Go To Event Settings &rsaquo;</Link>
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div>
              <div className="main-content guest-table">
                <div>
                  <div className="col-xs-12 navbar-default">
                    <div className="nav navbar-nav navbar-left">
                      {checkedRows.length > 0 ? (
                        <ul className="list-inline">
                          <li>
                            <Dropdown ref={(c) => { this.bulkActionsDropdown = c; }}>
                              <DropdownTrigger className="btn-dropdown btn-dropdown-secondary navbar-btn btn btn-boxed">
                                <div className="visible-xs visible-sm">
                                  <span>Bulk Actions</span>
                                  <i className="zolaicon zolaicon-chevron-down" />
                                </div>
                                <div className="with-tooltip hidden-xs hidden-sm" data-tooltip="Perform actions on multiple guests at once.">
                                  <span>Bulk Actions</span>
                                  <i className="zolaicon zolaicon-chevron-down" />
                                </div>
                              </DropdownTrigger>
                              <DropdownContent>
                                <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-left">
                                  <li>
                                    <a role="button" onClick={() => { onGuestMessage(checkedRows); this.bulkActionsDropdown.hide(); }}>Send Message</a>
                                  </li>
                                </ul>
                              </DropdownContent>
                            </Dropdown>
                          </li>
                          <li>
                            {checkedRows.length} Selected. <a role="button" onClick={this.unCheckAllRows}>Clear Selection</a>
                          </li>
                        </ul>
                      ) : (
                        <ul className="list-inline filter-search-ul">
                          <li>
                            <Dropdown>
                              <DropdownTrigger className="btn-dropdown navbar-btn btn btn-boxed">
                                <div className="hidden-xs hidden-sm">
                                  {numSelectedFacets ? (
                                    <span>{numSelectedFacets} Filters Selected</span>
                                  ) : (
                                    <div className="with-tooltip" data-tooltip="View specific groups of guests and perform bulk actions."><span>Filter Guests ({numGuests})</span></div>
                                  )}
                                  <i className="zolaicon zolaicon-chevron-down" />
                                </div>
                                <div className="hidden-md hidden-lg">
                                  {numSelectedFacets ? (
                                    <span>{numSelectedFacets} Filters Selected</span>
                                  ) : (
                                    <span>Filter Guests ({numGuests})</span>
                                  )}
                                  <i className="zolaicon zolaicon-chevron-down" />
                                </div>
                              </DropdownTrigger>
                              <DropdownContent className="">
                                <div className="dropdown-menu dropdown-menu-left">
                                  <Facets selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} onResetFacets={this.resetFacets} />
                                </div>
                              </DropdownContent>
                            </Dropdown>
                          </li>
                          <li>
                            <div className="has-feedback has-feedback-left">
                              <span className="zolaicon clear-search hidden" />
                              <i className="glyphicon glyphicon-search form-control-feedback hidden-xs hidden-sm" />
                              <input
                                className="form-control search"
                                type="search"
                                placeholder="Search Guest List"
                                onChange={e => onSearchFilterGuestList(e)}
                                value={searchValue}
                              />
                            </div>
                          </li>
                        </ul>
                      )}
                    </div>
                    <div className="nav navbar-nav navbar-right">
                      <ul className="list-inline">
                        <li className="with-tooltip no-tooltip-on-mobile" data-tooltip="Export guest RSVPs to a spreadsheet.">
                          <Dropdown ref={(c) => { this.exportDropdown = c; }}>
                            <DropdownTrigger className="btn btn-secondary navbar-btn">Export RSVPs <i className="zolaicon zolaicon-chevron-down" /></DropdownTrigger>
                            <DropdownContent className="">
                              <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/rsvp-overview-excel" onClick={this.afterExport}>Excel Format</a>
                                </li>
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/rsvp-overview" onClick={this.afterExport}>.csv Format</a>
                                </li>
                              </ul>
                            </DropdownContent>
                          </Dropdown>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filteredIds.length === 0 ? (
                    <div className="col-xs-12 text-center">
                      <h3>No Results Found</h3>
                      <p>Try adjusting your search or filter to find what you&apos;re looking for.</p>
                      <button className="btn btn-primary margin-top-2x" onClick={this.showAllGuests}>Show All Guests</button>
                    </div>
                  ) : (
                    <div className="col-xs-12">
                      <StickyHeaderTable
                        StickyHeader={RsvpEventHeader}
                        StaticTable={RsvpEventTable}
                        dataPropName={'guestGroups'}
                        stickyHeaderCls="table guest-table-v2"
                        checkAllRows={this.checkAllRows}
                        checkedAllRows={checkedAllRows}
                        sortByNameAsc={sortByNameAsc}
                        onToggleSort={onToggleSort}
                        filteredIds={filteredIds}
                        guestGroups={guestGroups}
                        onEditGuestGroup={onEditGuestGroup}
                        selectedGuestGroupId={selectedGuestGroupId}
                        checkedRows={checkedRows}
                        checkRow={this.checkRow}
                        onSelectGuestGroup={onSelectGuestGroup}
                        editGuestModalOpen={editGuestModalOpen}
                        events={events}
                        activeEventTab={activeEventTab}
                        mealOptions={mealOptions}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

RsvpEvent.propTypes = {
  getGuestList: PropTypes.func.isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  guestGroups: PropTypes.shape({}),
  globalStats: PropTypes.arrayOf(PropTypes.shape({})),
  numGuests: PropTypes.number,
  numSelectedFacets: PropTypes.number,
  onToggleFacet: PropTypes.func.isRequired,
  sortByNameAsc: PropTypes.bool,
  onToggleSort: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  onGuestMessage: PropTypes.func.isRequired,
  onUnload: PropTypes.func.isRequired,
  editGuestModalOpen: PropTypes.bool,
  initialized: PropTypes.bool,
  onConfirmation: PropTypes.func,
  onSearchFilterGuestList: PropTypes.func,
  searchValue: PropTypes.string,
  filteredIds: PropTypes.arrayOf(PropTypes.number),
  onResetSearchValue: PropTypes.func,
  onSelectGuestGroup: PropTypes.func,
  selectedGuestGroupId: PropTypes.number,
  events: PropTypes.shape({}),
  activeEventTab: PropTypes.number,
  onSelectEventTab: PropTypes.func,
  mealOptions: PropTypes.shape({}),
  params: PropTypes.shape({}),
};

const mapStateToProps = state => ({
  events: state.events.events,
  activeEventTab: state.guestList.guests.activeEventTab,
  mealOptions: _.flatMap(state.events.events.byId, event => event.meal_options).reduce((result, mealOption) => {
    result[mealOption.id] = mealOption; // eslint-disable-line
    return result;
  }, {})
});

const mapDispatchToProps = dispatch => ({
  getGuestList: () => dispatch(fetchRsvpOverviewList()),
  onAddGuestGroup: guestGroupType => dispatch(showModal('ADD_GUEST_GROUP_V2', { callback: () => dispatch(fetchRsvpOverviewList()), guestGroupType })),
  onEditGuestGroup: (guestGroupId, eventId) => {
    const callback = () => dispatch(fetchRsvpOverviewList());
    return dispatch(getGuestGroup(guestGroupId))
      .then(() => dispatch(showModal('EDIT_GUEST_GROUP_V2', { guestGroupId, activeTab: 'RSVP', activeEventTab: eventId, callback })));
  },
  onToggleFacet: (facetKey, facetValue) => dispatch(toggleRsvpFacetValueV2(facetKey, facetValue)),
  onToggleSort: () => {
    dispatch(toggleSortByNameAsc());
    dispatch(fetchRsvpOverviewList());
  },
  onSelectEventTab: eventId => dispatch(selectEventTab(eventId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RsvpEvent);



/** WEBPACK FOOTER **
 ** ./src/components/manage/guestlist/RsvpEvent.jsx
 **/